import React, { Component, createRef } from 'react';
import { getPreLayoutSignalsSections, SchematicPlot, SCHEMATIC_ELEMENTS_TYPES, PRE_TEMPLATE, getCanvasPortPins } from '../../../../../services/Sierra/prelayout/Schematic';
import { Input, Descriptions, Tooltip } from "antd";
import {
  DoubleLeftOutlined,
  DoubleRightOutlined,
  DeleteOutlined,
  CloseOutlined,
  FormOutlined
} from '@ant-design/icons';
import { COMP_REPEATER, DIODE } from '../../../../../constants/componentType';
import CompInfoPanel from './compInfoPanel';
import { numberCheck } from '../../../../../services/helper/dataProcess';
import SignalSectionTemplate from './signalSectionTemplate';
import preLayoutLibraryData from '../../../../../services/Sierra/library/PreLayoutData';
import { signalTypes, TRACE } from '../../../../../constants/libraryConstants';
import { RLC_TYPES } from '../../../../../services/PCBHelper';
import { getDefaultName } from '../../../../../services/helper/setDefaultName';
import './index.css'
import PortsRender from './portsRender';
import ModelTable from './modelTable';
import _ from "lodash";

const DescItem = Descriptions.Item;
class Canvas extends Component {

  constructor(props) {
    super(props);
    this.state = {
      openElements: true,
      openComp: null,
      newComp: null,
      openedCompUpdate: false,
      canvasContainer: {},
      openSectionTemplate: null,
      openedTemplateUpdate: false,
      signalHeight: 60,
      expandComps: [],
      showModelTable: false
    }
    this.eleRef = createRef();
    this.svgRef = createRef();

  }

  componentDidMount() {
    /*  this.initData(); */
    if (this.props.onRef) {
      this.props.onRef(this)
    }
  }

  componentDidUpdate = (prevProps) => {
    const { width, canvasUpdate, height, isReset, canvasConfig, libraryTreeInfo, mode } = this.props;

    const update = canvasUpdate && canvasUpdate !== prevProps.canvasUpdate;
    const reset = isReset && isReset !== prevProps.isReset;

    if (reset || update) {
      this.initData();
    } else if (width !== prevProps.width || height !== prevProps.height) {
      this.schematic && this.schematic.initContainer({ width, height, container: canvasConfig });
      this.schematic && this.schematic.draw();
    }

    if (libraryTreeInfo && libraryTreeInfo.length && (!prevProps.libraryTreeInfo || libraryTreeInfo.length !== prevProps.libraryTreeInfo.length) && libraryTreeInfo.includes(TRACE)) {
      this.getLibraryList(libraryTreeInfo)
      this.props._updateLibraryTree(null);
    }

    if (mode !== prevProps.mode) {
      this.setState({
        showModelTable: mode === "Model" ? true : false
      })
      this.schematic && this.schematic.removeTemplateText()
    }
  }

  getLibraryList = () => {
    if (this.schematic && this.schematic.reDrawLines) {
      this.schematic.reDrawLines()
    }
  }

  initData = () => {
    this.initPlot();
  }

  initPlot = () => {
    const { width, canvasConfig, GPIO, signalNumber, height, isSweep, isPuppeteer, mode } = this.props;
    const canvasContainer = {
      width: 22,
      height: 16,
      ...canvasConfig || {},
    }
    this.setState({
      canvasContainer,
      expandComps: [],
      showModelTable: mode === "Model" ? true : false,
      openComp: null,
      openedCompUpdate: false
    }, () => {
      this.schematic = new SchematicPlot({
        elementsSvg: this.eleRef.current,
        schematicSvg: this.svgRef.current,
        width,
        height,
        top: 72,//W,H content
        elementsTypes: [...SCHEMATIC_ELEMENTS_TYPES],
        GPIO,
        signalNumber,
        isSweep,
        isPuppeteer,
        action: {
          compUpdate: this.compUpdate,
          openCompBox: this.openCompBox,
          closeCompBox: this.closeCompBox,
          saveNewComponent: this.saveNewComponent,
          getParam: this.getParam,
          /*   signalsUpdate: this.signalsUpdate, */
          selectSignalSection: this.selectSignalSection,
          updatePreLayoutInfo: this.updatePreLayoutInfo,
          showTemplateInfo: this.showTemplateInfo,
          closeTemplateInfo: this.closeTemplateInfo,
          drawRectPorts: this.drawRectPorts
        }
      });
      this.schematic.draw();
      setTimeout(() => {
        this.props.updateSchematicLoading(false);
        this.props.updateCanvasStatus && this.props.updateCanvasStatus(false);
        isPuppeteer && this.props.drawCompleted && this.props.drawCompleted()
      }, 500)
      this.getSignalsContentHeight()
    })
  }

  getSignalsContentHeight = () => {
    const { signals } = this.props;
    if (!signals || !signals.length) {
      this.setState({
        signalHeight: 0
      })
      return
    }
    const ele = document.getElementById("sierra-pre-layout-signals-data-main");
    if (ele && ele.offsetHeight) {
      this.setState({
        signalHeight: ele.offsetHeight
      })
    }
  }

  getParam = (key, type = "props") => {
    if (key === "mode") {
      return this.props.mode || PRE_TEMPLATE;
    }
    if (!key || !type) {
      return [];
    }
    return this[type] ? JSON.parse(JSON.stringify(this[type][key] || [])) : [];
  }

  saveNewComponent = (newComp) => {
    const { components } = this.props;
    let _components = JSON.parse(JSON.stringify(components || []));
    _components.push({ ...newComp });
    this.props.updateComponents && this.props.updateComponents(_components);
  }

  updatePreLayoutInfo = (info) => {
    const { expandComps } = this.state;
    let _expandComps = [...expandComps];
    let delComps = [];
    if (info.components) {
      for (let comp of _expandComps) {
        const findComp = info.components.find(item => item.name === comp.name);
        if (!findComp) {
          delComps.push(comp.name)
        }
        const pins = (findComp.pins || []).map(item => `${comp.name}::${item.pin}`);
        const expandPins = comp.pins.filter(item => item.comp === comp.name).map(item => `${comp.name}::${item.pin}`);
        if (!_.isEqual(pins, expandPins)) {
          delComps.push(comp.name)
        }
      }
    }

    if (delComps.length) {
      _expandComps = _expandComps.filter(item => !delComps.includes(item.name));
      this.setState({
        expandComps: _expandComps
      })
      this.schematic.closeExpand(delComps);
    }

    this.props.updatePreLayoutData && this.props.updatePreLayoutData({ ...info });
    setTimeout(() => {
      this.getSignalsContentHeight();
    }, 10)
  }

  removeAllSignals = (signalName) => {
    const { expandComps } = this.state;
    const expandCompNames = expandComps.map(it => it.name);
    this.schematic.closeExpand(expandCompNames);
    this.setState({
      expandComps: []
    }, () => {
      this.schematic && this.schematic.removeAllSignals(signalName)
    })
  }

  removeSignalSection = (signalName, sectionId) => {
    this.schematic && this.schematic.removeSignalSection(signalName, sectionId)
  }

  compUpdate = (comp, action) => {
    const { isUpdate, isDelete } = action || {}
    const { components } = this.props;
    const { openComp } = this.state;
    let _components = JSON.parse(JSON.stringify(components));
    if (isUpdate) {
      const index = _components.findIndex(item => item.name === comp.name);
      if (index < 0) {
        return;
      }
      _components[index].location = comp.location;
      _components[index].pins = comp.pins;
      _components[index].width = comp.width;
      _components[index].height = comp.height;
    }

    if (isDelete) {
      _components = _components.filter(item => item.name !== comp.name);
      this.setState({
        openComp: openComp && openComp.name === comp.name ? null : openComp,
      })
    }

    this.props.updateComponents(_components);
  }

  /*   signalsUpdate = (signal, action) => {
      const { isUpdate, isDelete, isAdd } = action || {}
      const { signals } = this.props;
      let _signals = JSON.parse(JSON.stringify(signals || []));
      if (isUpdate) {
        const index = _signals.findIndex(item => item.name === signal.name);
        if (index < 0) {
          return;
        }
        _signals[index].sections = signal.sections;
        _signals[index].points = signal.points;
        _signals[index].color = signal.color;
        _signals[index].name = signal.newName || signal.name;
        _signals[index].nets = signal.nets;
      }
  
      if (isAdd) {
        _signals.push(signal);
      }
  
      if (isDelete) {
        _signals = _signals.filter(item => item.name !== signal.name);
      }
  
      this.props.updatePreLayoutData({ signals: _signals, keys: ["signals"] });
    } */

  selectSignalSection = (signalName, sectionId) => {
    const { signals } = this.props;
    const { openSectionTemplate } = this.state;
    if (openSectionTemplate && openSectionTemplate.signal === signalName && openSectionTemplate.sectionId === sectionId) {
      return;
    }
    const signal = signals.find(item => item.name === signalName);
    const section = signal.sections.find(item => item.id === sectionId);
    this.setState({
      openSectionTemplate: {
        signal: signalName,
        sectionId,
        template: section.template,
        traceLength: section.traceLength
      },
      openedTemplateUpdate: true
    })
  }

  sweepSectionSelection = ({ secId, expId, template, differentialSections }) => {
    const { openSectionTemplate } = this.state;
    if (openSectionTemplate && openSectionTemplate.sectionId === secId) {
      return;
    }
    this.setState({
      openSectionTemplate: {
        sectionId: secId,
        template: template || {},
        expId,
        differentialSections
      },
      openedTemplateUpdate: true
    })
  }

  closeSectionTemplate = () => {
    this.setState({
      openSectionTemplate: null
    })
  }

  saveComp = (newComp, applyComps, namePrefix, isCompUpdate) => {
    const { components, signals } = this.props;
    let _components = JSON.parse(JSON.stringify(components)), comps = [], _signals = JSON.parse(JSON.stringify(signals)), isUpdateSignals = false;
    const index = _components.findIndex(item => item.name === newComp.prevName);
    if (index < 0) {
      return;
    }
    let newComps = [];
    newComps.push(newComp.name)
    let prevType = _components[index].type, prevName = _components[index].name;
    let updateTypes = [];
    if (applyComps && applyComps.length) {
      //RLC

      for (let comp of _components) {
        if (applyComps.includes(comp.name) && comp.name !== newComp.prevName) {
          const prevCompName = comp.name;
          if (namePrefix) {
            const compNames = [newComp.name, ..._components.filter(it => it.name !== prevCompName).map(it => it.name)];
            comp.name = getDefaultName({ nameList: compNames, defaultKey: namePrefix, key: "", firstIndex: 1 });
            const { signals: newSignals, isUpdateSignals: _isUpdateSignals } = this.updateCompNameInSection(_signals, prevCompName, comp.name);
            _signals = newSignals;
            isUpdateSignals = _isUpdateSignals ? _isUpdateSignals : isUpdateSignals;
          }

          comp.type = newComp.type;
          comp.voltage = newComp.voltage;
          if (comp.type === DIODE) {
            comp.model = { ...(newComp.model || {}) };
            /*   for (let pair of comp.model.pairs || []) {
                if (pair.pin !== "VDD/GND") {
                  pair.pin=comp.pins[0].pin
                }
              } */
            updateTypes.push("model")
          } else {
            comp.value = newComp.value;
            updateTypes.push("value")
          }
          updateTypes.push("voltage");
          comps.push({
            prevName: prevCompName,
            ...comp
          })
          newComps.push(comp.name)
        }
      }
    }

    if (newComp.name !== prevName) {
      const { signals: newSignals, isUpdateSignals: _isUpdateSignals } = this.updateCompNameInSection(_signals, prevName, newComp.name);
      _signals = newSignals;
      isUpdateSignals = _isUpdateSignals ? _isUpdateSignals : isUpdateSignals;
    }
    _components[index].name = newComp.name;
    _components[index].type = newComp.type;

    if (RLC_TYPES.includes(newComp.type)) {
      _components[index].value = newComp.value;
      _components[index].voltage = newComp.voltage || "";
      updateTypes.push("value", "voltage");
    }

    if (newComp.type === DIODE) {
      _components[index].voltage = newComp.voltage || "";
      _components[index].model = newComp.model || {};
      updateTypes.push("model", "voltage");
    }

    if (newComp.type === COMP_REPEATER) {
      _components[index].model = newComp.model || {};
      updateTypes.push("model");
    }

    if (isUpdateSignals) {
      this.props.updatePreLayoutData({ signals: _signals, components: _components, keys: ["signals", "components"] });
    } else {
      this.props.updateComponents(_components);
    }

    const isUpdate = _components[index].type !== prevType || _components[index].name !== prevName;
    if (isUpdate || updateTypes.length) {
      comps.push({
        prevName,
        ..._components[index]
      })
      isUpdate && updateTypes.push("name", "type");
    }
    updateTypes = [...new Set(updateTypes)];
    updateTypes.length && this.schematic.updateCanvas({ comps, signals: _signals, update: updateTypes, isUpdateSignals })
    newComp.comps = newComps;

    if (!isCompUpdate) {
      this.setState({
        openComp: newComp
      })
    }
  }

  updateCompNameInSection = (_signals, prevName, newName) => {
    let isUpdateSignals = false;
    _signals.forEach(item => {
      (item.sections || []).forEach(secItem => {
        if (secItem.in && secItem.in.type === "component" && secItem.in.component === prevName) {
          secItem.in.component = newName;
          isUpdateSignals = true;
        }
        if (secItem.out && secItem.out.type === "component" && secItem.out.component === prevName) {
          secItem.out.component = newName;
          isUpdateSignals = true;
        }
      });
      (item.points || []).forEach(poiItem => {
        (poiItem.points || []).forEach(poi => {
          if (poi.type === "component" && poi.name === prevName) {
            poi.name = newName;
            isUpdateSignals = true;
          }
        })
      })
    })
    return { isUpdateSignals, signals: _signals }
  }

  openCompBox = (comp, comps) => {
    this.setState({
      openComp: !comp ? null : {
        ...comp,
        comps
      },
      openedCompUpdate: comp ? true : false
    })
  }

  closeCompBox = () => {
    this.setState({
      openComp: null,
      openedCompUpdate: false
    })
  }

  changeOpenCompStatus = () => {
    this.setState({
      openedCompUpdate: false
    })
  }

  updateShowElements = (e) => {
    this.setState({
      openElements: !this.state.openElements
    })
  }

  keyDown = (e) => {
    if (e.keyCode === 13) {
      e.target.blur();
    }
  }

  updateCanvasContainer = (e, key) => {
    const value = e.target.value;
    this.setState({
      canvasContainer: { ...this.state.canvasContainer, [key]: value }
    })
  }

  saveCanvasContainer = (e, key) => {
    let check = null;
    const value = e.target.value;
    const { canvasConfig = {} } = this.props;
    const { canvasContainer } = this.state;
    if (canvasContainer[key] === canvasConfig[key]) {
      return;
    }

    check = numberCheck(value);

    if (check) {
      this.setState({
        canvasContainer: { ...this.state.canvasContainer, [key]: canvasConfig[key] }
      })
    } else {
      const newConfig = { ...canvasContainer, [key]: value }
      this.props.updateCanvasConfig && this.props.updateCanvasConfig(newConfig);
      this.schematic.updateCanvasContainer({ ...newConfig });
      this.props.getCanvasWidth && this.props.getCanvasWidth(false, newConfig)
    }
  }

  changeOpenTemplateStatus = (openedTemplateUpdate) => {
    this.setState({
      openedTemplateUpdate
    })
  }

  showTemplateInfo = ({ x, y, id, name, length }) => {
    const data = preLayoutLibraryData.getLibrary(id, TRACE) || {};
    this.setState({
      showTemplateData: {
        x,
        y,
        id,
        name: data.name || name,
        length,
        data
      }
    })
  }

  closeTemplateInfo = () => {
    this.setState({
      showTemplateData: null
    })
  }

  getLeftContentHeight = () => {
    const filterTypes = SCHEMATIC_ELEMENTS_TYPES.filter(it => it !== DIODE);
    let _height = filterTypes.length ? filterTypes.length * 55 + 20 + 72 : 200;
    //72 is top (W,H)

    if (SCHEMATIC_ELEMENTS_TYPES.includes(DIODE)) {
      _height = _height + 90
    }
    return _height
  }

  drawRectPorts = ({ rectItem, xGridSize, yGridSize, dirList, closeIconLocation }) => {
    const { expandComps } = this.state;
    let _expandComps = [...expandComps];
    const findItem = _expandComps.find(it => it.name === rectItem.name);
    if (findItem) {
      return;
    }
    //   let names = [rectItem.name, ...(rectItem.names || [])];

    const { components, signals } = this.props;
    const findComp = components.find(comp => comp.name === rectItem.name);
    if (!findComp) {
      return;
    }
    const pins = getCanvasPortPins({ dirList, findComp, components, rectItem, signals, xGridSize, yGridSize });

    _expandComps.push({
      name: rectItem.name,
      comps: rectItem.names || [],
      type: findComp.type,
      dirList,
      pins,
      isSeries: RLC_TYPES.includes(findComp.type) && findComp.pins.length === 2,
      closeIconLocation
    })
    this.setState({
      expandComps: _expandComps,
      xGridSize,
      yGridSize
    })
  }

  savePinModel = (pin, model) => {
    const { comp, pin: pinName } = pin;
    const { components } = this.props;
    const { expandComps } = this.state;
    let _components = JSON.parse(JSON.stringify(components));
    const compIndex = _components.findIndex(item => item.name === comp);
    if (compIndex < 0) {
      return;
    }
    const pinIndex = _components[compIndex].pins.findIndex(item => item.pin === pinName);
    if (pinIndex > -1) {
      _components[compIndex].pins[pinIndex].model = model;
      this.props.updateComponents(_components);
    }

    let _expandComps = [...expandComps];
    let index = _expandComps.findIndex(item => item.name === comp);
    if (index < 0) {
      index = _expandComps.findIndex(item => item.comps.includes(comp));
    }

    if (index < 0) {
      this.schematic.updateCanvas({ comps: [_components[compIndex]], update: ["pinModel"], pins: [`${comp}::${pinName}`] })
      return;
    }

    const _pinIndex = (_expandComps[index].pins || []).findIndex(item => item.comp === comp && item.pin === pinName);
    if (_pinIndex > -1) {
      _expandComps[index].pins[_pinIndex].model = { ...(model || {}) };
    }
    this.schematic.updateCanvas({ comps: [_components[compIndex]], update: ["pinModel"], pins: [`${comp}::${pinName}`] })

    this.setState({
      expandComps: _expandComps
    })
  }

  clearPinModel = (libraryList) => {
    const { expandComps } = this.state;
    let _expandComps = [...expandComps];
    let updateComps = [], updatePins = [];

    for (let comp of _expandComps) {
      for (let pin of comp.pins) {
        if (!pin.model || !pin.model.libraryId) {
          continue;
        }
        if (!libraryList) {
          pin.model = { libraryId: "", subckt: "", port: "" };
          updateComps.push(comp.name);
          updatePins.push(`${comp.name}::${pin.pin}`);
          continue;
        }
        if (libraryList.find(item => item.libraryId === pin.model.libraryId && (!item.subckt || item.subckt === pin.model.subckt))) {
          pin.model = { libraryId: "", subckt: "", port: "" };
          updateComps.push(comp.name);
          updatePins.push(`${comp.name}::${pin.pin}`);
        }
      }
    }

    this.schematic.updateCanvas({ comps: updateComps, update: ["pinModel"], pins: updatePins })

    this.setState({
      expandComps: _expandComps
    })
  }

  closeExpandComp = (e, comp) => {
    const { expandComps } = this.state;
    let _expandComps = [...expandComps];
    _expandComps = _expandComps.filter(item => item.name !== comp.name);
    this.setState({
      expandComps: _expandComps
    })
    this.schematic.closeExpand([comp.name])
  }

  changeModelTableStatus = (status) => {
    this.setState({
      showModelTable: status
    })
  }

  render() {
    const { id, width, height, isSweep, components, libraryTreeInfo, signals, maxWidth, maxHeight, libraries, portsObj, model, fixed, lastOpenModel, mode, differentialSections, isSweepBase, selectSections } = this.props;
    const { openElements, openComp, openedCompUpdate, openSectionTemplate, openedTemplateUpdate, showTemplateData, signalHeight, expandComps, showModelTable } = this.state;
    const leftHeight = this.getLeftContentHeight();
    return <div className='sierra-pre-layout-canvas sierra-pre-layout-schematic-canvas'
      id={`pre-layout-schematic-${id}`}>
      {!isSweep ? <div className='schematic-canvas-component-content' style={openElements ? { width: 140, height: leftHeight + signalHeight || 0 } : { width: 30, height: 30 }}>
        <div className={`schematic-canvas-component-icon ${openElements ? "" : "schematic-canvas-component-right-icon"}`} onClick={(e) => this.updateShowElements(e)}>
          {openElements ? <DoubleLeftOutlined /> : <DoubleRightOutlined />}
        </div>
        {openElements ? this.getContainerRender() : null}
        {openElements ? this.showSignalRender(leftHeight) : null}
        <svg
          id={`pre-layout-schematic-canvas-elements-${id}`}
          className="pre-layout-schematic-canvas-elements-svg"
          ref={this.eleRef}
          //width={120}
          // height={200}
          display={openElements ? "block" : "none"}
        >
        </svg>
      </div> : null}
      <svg id={`pre-layout-schematic-canvas-${id}`}
        className="pre-layout-canvas"
        ref={this.svgRef}
        width={width}
        height={height} />

      {!isSweep && openComp && openComp.name ? <CompInfoPanel
        comp={openComp}
        components={components}
        signals={signals}
        openElements={openElements}
        openedCompUpdate={openedCompUpdate}
        libraryTreeInfo={libraryTreeInfo}
        id={id}
        maxWidth={maxWidth}
        maxHeight={maxHeight}
        saveComp={this.saveComp}
        _updateLibraryTree={this.props._updateLibraryTree}
        changeOpenCompStatus={this.changeOpenCompStatus}
        closePanel={() => this.closeCompBox()} /> : null}
      {openSectionTemplate && openSectionTemplate.sectionId ?
        <SignalSectionTemplate
          openSectionTemplate={openSectionTemplate}
          isSweep={isSweep}
          signals={signals}
          differentialSections={differentialSections}
          openedTemplateUpdate={openedTemplateUpdate}
          isSweepBase={isSweepBase}
          selectSections={selectSections}
          closePanel={this.closeSectionTemplate}
          _reDrawSignals={this.schematic ? this.schematic.reDrawSignals : null}
          changeOpenTemplateStatus={this.changeOpenTemplateStatus}
          saveSweepPreTraceTemplate={this.props.saveSweepPreTraceTemplate}
        /> : null}
      {showTemplateData ? this.getTemplateInfoTooltip(showTemplateData, id) : null}
      {expandComps && expandComps.length ?
        <PortsRender
          expandComps={expandComps}
          components={components}
          libraries={libraries}
          portsObj={portsObj}
          model={model}
          fixed={fixed}
          lastOpenModel={lastOpenModel}
          selectOpenModel={this.props.selectOpenModel}
          saveModel={this.savePinModel}
          closeExpandComp={this.closeExpandComp}
        /> : null}
      {mode === "Model" ? <ModelTable
        showModelTable={showModelTable}
        id={id}
        components={components}
        model={model}
        signals={signals}
        libraries={libraries}
        portsObj={portsObj}
        fixed={fixed}
        lastOpenModel={lastOpenModel}
        saveModel={this.savePinModel}
        selectOpenModel={this.props.selectOpenModel}
        changeModelTableStatus={(status) => this.changeModelTableStatus(status)}
      /> : null}
      {this.componentEditIconRender()}
    </div>
  }

  getContainerRender = () => {
    const { canvasContainer = {} } = this.state;
    return <div className='schematic-canvas-container-content'>
      <div className='schematic-canvas-container-item'>
        <span>W</span>
        <Input
          className="aurora-input"
          value={canvasContainer.width}
          onChange={(e) => this.updateCanvasContainer(e, "width")}
          onBlur={(e) => this.saveCanvasContainer(e, "width")}
          onKeyDown={this.keyDown}
        />
      </div>
      <div className='schematic-canvas-container-item'>
        <span>H</span>
        <Input
          className="aurora-input"
          value={canvasContainer.height}
          onChange={(e) => this.updateCanvasContainer(e, "height")}
          onBlur={(e) => this.saveCanvasContainer(e, "height")}
          onKeyDown={this.keyDown}
        />
      </div>
    </div>
  }

  showSignalRender = (top) => {
    const { signals, isPuppeteer } = this.props;
    if (!signals || !signals.length) {
      return;
    }
    const sections = getPreLayoutSignalsSections(signals);
    const firstSignal = signals.find(item => item.points && item.points.length) || {};
    return <div className="sierra-pre-layout-signals-main" id="sierra-pre-layout-signals-data-main" style={{ top }}>
      <div className="sierra-pre-layout-signals-title">
        <span>Signals:</span>
        {!isPuppeteer ? <DeleteOutlined
          className="sierra-pre-layout-signals-del-icon"
          title="Remove All Signals"
          onClick={() => this.removeAllSignals(firstSignal.name)} /> : null}
      </div>
      <div className="sierra-pre-layout-signals-content">
        <div className="sierra-pre-layout-signals-content-names sierra-pre-layout-signals-name">
          {signals.map((item, index) => <span style={{ color: item.color }} key={item.name}>{item.name}{index === signals.length - 1 ? "" : ", "}</span>)}
        </div>
      </div>
      <div className="sierra-pre-layout-signals-content">
        <div className="sierra-pre-layout-signals-title">
          <span>Sections:</span>
        </div>
        {sections.map(item =>
          <div className="sierra-pre-layout-signals-content-names" key={item.id}>
            <span title={item.title} className="sierra-pre-layout-signals-section-name">{item.title}</span>
            {!isPuppeteer ? <CloseOutlined
              className="sierra-pre-layout-signals-del-icon"
              title="Remove This Section"
              onClick={() => this.removeSignalSection(firstSignal.name, item.id)}
            /> : null}
          </div>
        )}
      </div>
    </div>
  }

  getTemplateInfoTooltip = (showTemplateData, id) => {
    const data = showTemplateData.data || {};
    const config = data.config || {};
    const findThickness = (config.layers || []).find(item => item.name === "Trace");
    const signalType = (signalTypes.find(item => item.key === config.type) || {}).title;
    const type = data.type || "";
    return <Tooltip
      styles={{ root: { left: showTemplateData.x, top: showTemplateData.y } }}
      title={<Descriptions size="small" column={1} bordered={true}>
        <DescItem label="Length">{showTemplateData.length || ""}</DescItem>
        <DescItem label="Template">{showTemplateData.name || ""}</DescItem>
        <DescItem label="Trace Type">{type.charAt(0).toUpperCase() + type.slice(1)}</DescItem>
        <DescItem label="Signal Type">{signalType || ""}</DescItem>
        <DescItem label="Width">{config.width ? `${config.width}${config.unit}` : ""}</DescItem>
        <DescItem label="Thickness">{findThickness && findThickness.thickness ? `${findThickness.thickness}${config.unit}` : ""}</DescItem>
      </Descriptions>}
      classNames={{ root: 'aurora-tooltip sierra-template-tooltip' }}
      placement='right'
      open={true}
      getPopupContainer={() => document.getElementById(`pre-layout-schematic-${id}`)}
    />
  }

  openExpandCompsByIcon = (e, comp) => {
    e && e.stopPropagation()
    const { signals } = this.props;
    let names = []
    if ([...RLC_TYPES, DIODE].includes(comp.type)) {
      const sections = getPreLayoutSignalsSections(signals);

      const findInSection = sections.find(it => it.in && it.in.includes(comp.name));
      const findOutSection = sections.find(it => it.out && it.out.includes(comp.name))
      if (findInSection && findInSection.in.length) {
        names.push(...findInSection.in)
      }
      if (findOutSection && findOutSection.out.length) {
        names.push(...findOutSection.out)
      }
      names = [...new Set(names)];
    }
    this.schematic.openExpandComps({ name: comp.name, names })
  }

  componentEditIconRender = () => {
    const { components, mode } = this.props;
    const { expandComps } = this.state;
    if (mode !== "Model" || !components || !components.length) {
      return;
    }
    const expandCompNames = (expandComps || []).map(item => item.name);
    const filterComps = components.filter(item => !expandCompNames.includes(item.name) && item.location && item.location.length && item.pins && item.pins.length && item.pins.find(it => !it.model || !it.model.port));
    let xGridSize = 0, yGridSize = 0;
    if (this.schematic) {
      xGridSize = this.schematic.getGridSize("x");
      yGridSize = this.schematic.getGridSize("y");
    }
    if (xGridSize <= 0 || yGridSize <= 0) {
      return;
    }
    return filterComps.map(comp => {
      return comp.location && comp.location.length ? <FormOutlined
        key={comp.name}
        title="This component has pins with unselected ports."
        className="sierra-pre-layout-schematic-edit-port-icon"
        onClick={(e) => this.openExpandCompsByIcon(e, comp)}
        style={{ left: comp.location[0] * xGridSize + 5, top: comp.location[1] * yGridSize + 4 }}
      /> : null
    }
    )
  }
}

export default Canvas;